import {coreApi} from './core/index'

export const paymentService = {
    getById: (id) => {
        return coreApi.get(`payment?id=${id}`)
    },
    payments: () => {
        return coreApi.get(`payment`)
    },
    create: (data) => coreApi.post(`payment`, data),
    update: (data) => coreApi.put(`payment`, data),
    delete: (id) => coreApi.delete(`payment/${id}`),
    paginate: (offset) => coreApi.get(`payment/${offset}`)
}